import { render, staticRenderFns } from "./alumnoForm.vue?vue&type=template&id=f905ffb4&"
import script from "./alumnoForm.vue?vue&type=script&lang=js&"
export * from "./alumnoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports